/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { connect } from "react-redux";
import cookie from "react-cookies";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Swal from "sweetalert2";
import { apiUrl, adminlimit, clientheaderconfig, ecommerceapiUrl } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import { decodeValue, encodeValue, removeItem, showDateTime } from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "referralsettings";
var moduleName = "Customer Referral History";
class List extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    this.state = {
      companyID: companyID,
      path: this.props?.location?.pathname || "",
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      loading: true,
      user: "",
      start_date: "",
      end_date: "",
      allowOutlet: cookie.load("clientAllowOutlet") ?? "",
      storeID: "",
      searchkewords:"",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(1);
    this.loadOutlet();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }

  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        },
      );
    }
  };
  removeItem(deleteID) {
    var params = { delete_id: deleteID, company_id: this.state.companyID };
    var delurl = module + "delete";
    removeItem(params, delurl, "client");
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }

  handleChangeDate(name, value) {
    this.setState({ [name]: value });
  }

  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addParams = "";
    
    if (this.state.searchkewords !== "") {
      addParams += "&searchkewords=" + this.state.searchkewords;
    }
    if (this.state.user !== "") {
      addParams += "&user=" + this.state.user.value;
    }
    if (cookie.load("clientID") !== "" && cookie.load("clientLoginType") === "SubAdmin") {
      addParams += "&user=" + decodeValue(cookie.load("clientID"));
    }

    if (this.state.start_date !== "" && this.state.end_date !== "") {
      addParams += "&from_date=" + moment(this.state.start_date).format("Y-MM-DD") + "&to_date=" + moment(this.state.end_date).format("Y-MM-DD");
    } else if (this.state.start_date !== "") {
      addParams += "&from_date=" + moment(this.state.start_date).format("Y-MM-DD");
    }

    if (this.state.storeID !== null && Object.keys(this.state.storeID).length > 0) {
      addParams += "&storeID=" + this.state.storeID.value;
    } else if (this.state.allowOutlet !== "") {
      addParams += "&storeID=" + this.state.allowOutlet;
    }

    var params = {
      params: "limit=" + adminlimit + "&offset=" + offset + addParams,
      url: apiUrl + module + "/referralHistory",
      authType: "client",
    };
    this.props.getListData(params);
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        email: "",
        userrole: "",
        status: "",
        storeID: "",
        start_date: "",
        end_date: "",
        searchkewords:""
      },
      function () {
        this.loadList(1);
      },
    );
  }
  loadOutlet() {
    var urlShringTxt = ecommerceapiUrl + "outlet/dropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ outletList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  confirmToCredit(referralID, e) {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want confirm this referral?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, confirm it!",
      customClass: {
        confirmButton: "btn btn-primary me-3 waves-effect waves-light",
        cancelButton: "btn btn-label-secondary waves-effect",
      },
      buttonsStyling: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        try {
          return axios
            .put(`${apiUrl}${module}/confirmToCredit/${encodeValue(referralID)}`, "", clientheaderconfig)
            .then((res) => {
              return res.data;
            })
            .catch((e) => {
              return e?.response?.data?.message || e.message;
            });
        } catch (err) {
          console.log(err);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      const value = result?.value ?? "";
      if (value !== "") {
        if (result.value.status === "ok") {
          Swal.fire({
            icon: "success",
            title: "Change Status!",
            text: result.value.message,
            customClass: {
              confirmButton: "btn btn-success waves-effect",
            },
          }).then(() => {
            this.loadList(this.state.currentPage);
          });
        } else {
          console.log(result, "resultresultresult");
          Swal.fire({
            title: "Alert",
            html: result.value?.message || result.value,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-danger waves-effect",
            },
          });
        }
      }
    });
  }

  render() {
    const clientUnquieID = cookie.load("clientUnquieID") ?? "";
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"referralsettinghistory"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <input type="text" className="form-control" name="searchkewords" onChange={this.handleChangeText} value={this.state.searchkewords} />
                      <label htmlFor="searchkewords">Name/Email/Number</label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <DatePicker
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control"
                        selected={this.state.start_date}
                        dateFormat="d-MM-yyyy"
                        placeholderText="Start Date"
                        onChange={this.handleChangeDate.bind(this, "start_date")}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <DatePicker
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control"
                        selected={this.state.end_date}
                        minDate={this.state.start_date !== "" ? this.state.start_date : ""}
                        dateFormat="d-MM-yyyy"
                        placeholderText="Start Date"
                        onChange={this.handleChangeDate.bind(this, "end_date")}
                      />
                    </div>
                  </div>
                  {this.state.allowOutlet === "" && (
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                        <Select value={this.state.storeID} onChange={this.handleSelectChange.bind(this, "storeID")} placeholder="Select Outlet" isClearable={true} options={this.state.outletList} />
                        <label className="select-box-label">Outlet</label>
                      </div>
                    </div>
                  )}
                  <div className="col-md-3 mt-2">
                    <button type="button" className="btn btn-primary me-sm-3 me-1 waves-effect waves-light" onClick={this.searchList.bind(this)}>
                      Search
                    </button>
                    <button type="reset" className="btn btn-label-secondary waves-effect me-sm-3 me-1" onClick={this.resetSearch.bind(this)}>
                      Reset
                    </button>
                  </div>
                </div>
                <div className="card">
                  <div className="table-responsive text-nowrap p-1 mt-4">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Action</th>
                          <th>Outlet</th>
                          <th>Referee Name</th>
                          <th>Referee Email</th>
                          <th>Referee Phone</th>
                          {clientUnquieID === "43bd4685-55a3-4207-b2ac-4f7da8c4f4ce" && <th>Trial Subject</th>}
                          <th>Referee Points</th>
                          <th>Referrer Type</th>
                          <th>Referrer Name</th>
                          <th>Referrer Phone</th>
                          <th>Referrer Email</th>
                          <th>Referrer Points</th>
                          <th>Referral On</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={6} align="center">
                              <div className="spinner-border spinner-border-lg text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.listdata.length > 0 ? (
                          this.state.listdata.map((item, index) => {
                            const referralCredited = item?.referralCredited || false;
                            return (
                              <tr key={index}>
                                <td>
                                  {!referralCredited ? (
                                    <button type="button" className="btn btn-primary me-sm-3 me-1 waves-effect waves-light" onClick={this.confirmToCredit.bind(this, item._id)}>
                                      Credit
                                    </button>
                                  ) : (
                                    `Credited`
                                  )}
                                </td>
                                <td>{item?.outlet?.outletName || ""}</td>
                                <td>
                                  <strong>{item.referralName}</strong>
                                </td>
                                <td>{item.referralEmail}</td>
                                <td>{item.referralPhone}</td>
                                {clientUnquieID === "43bd4685-55a3-4207-b2ac-4f7da8c4f4ce" && <td>{item?.trialSubject || ""}</td>}
                                <td>{item.refereePoints}</td>
                                <td>{item?.customer?.customerName ? "Customer" : "Non Customer"}</td>
                                <td>
                                  <strong>{item?.referrerName || item?.customer?.customerName}</strong>
                                </td>
                                <td>{item?.referrerPhone || item?.customer?.customerPhone}</td>
                                <td>{item?.customer?.customerEmail}</td>
                                <td>{item?.customer?.customerName ? item.referrerPoints : ""}</td>
                                <td>{showDateTime(item.createdAt)}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={9}>
                              No {moduleName} Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  var listdataStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    listdataStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
